import React from 'react';
import './index.css';

import subDays from "date-fns/subDays";
import DatePicker from "react-datepicker";
import "./react-datepicker-choose.css";
import translate from '../../../classes/lang';
import errCode from '../../../classes/errorCode';

const AddMemberCalendar = require('./AddMember').default

const { rxgetLocal } = global.rootRequire('classes/request')
const { rxaget, rxChangeSlug, isElectron } = global.rootRequire('classes/ulti')
const { changeColorAva, textAva } = global.rootRequire('classes/chat')

const days = ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7']

const months = ['Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5', 'Tháng 6', 'Tháng 7', 'Tháng 8', 'Tháng 9', 'Tháng 10', 'Tháng 11', 'Tháng 12']

const locale = {
  localize: {
    day: n => days[n],
    month: n => months[n]
  },
  formatLong: {
    date: () => 'mm/dd/yyyy',
    time: () => 'HH:mm'
  }
}

export function subString(str, pos) {
  pos = pos || 33
  let result = ''
  if (str && typeof (str) === 'string' && str.length > pos) {
    result = str.substr(0, pos) + ' ...'
  } else {
    result = str
  }

  return result
}


export function convertUnixToDateTime(UNIX_timestamp, type) {
  var date = new Date(UNIX_timestamp * 1000)

  var year = date.getFullYear()
  var month = ("0" + (Number(date.getMonth()) + 1)).substr(-2)
  var day = ("0" + date.getDate()).substr(-2)
  var hour = ("0" + date.getHours()).substr(-2)
  var minutes = ("0" + date.getMinutes()).substr(-2)

  if (type === 'hour') {
    return hour + ':' + minutes
  } else if (type === 'date') {
    return day + '/' + month + '/' + year
  } else {
    return year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':00'
  }
}

export function convertUnixTimeDate(datestr) {
  return Math.floor((new Date(datestr).getTime()) / 1000)
}


// Create component class for calendar
class CreateCalendar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: Math.floor(Date.now() / 1000) + 3600,
      endDate: Math.floor(Date.now() / 1000) + 7200,
      selectedDate: new Date(),
      arrData: [],
      arrRecipients: [],
      arrRecipientsOrigin: [],
      arrReminder: [],
      arrReminderChannel: [],
      arrBlacklistTime: [],
      objLocation: {},
      objCategory: {},
      toggleShowTime: false,
      flagPopupDateTime: false,
      flagPopupTypeCalendar: false,
      flagNoteDescCalendar: false,
      flagReminder: false,
      flagReminderChannel: false,
      flagReminderStatus: false,
      flagShowMember: false,
      flagShowLocation: false,
      flagShowCategory: false,
      flagRecipientsMember: false,
      flagEditCalendar: props.flagEdit || false,
      flagCheckEdit: false,
      flagPopupConfirm: false,
      flagCheckEditTime: false,

      flagClickDate: '',

      typeCalendar: '',
      typeReminder: '',
      typeReminderChannel: 0,
      typeReminderStatus: 'A',
      typeLocation: '',
      typeCategory: '',

      cntCharTextArea: 0,
      cntCharInput: 0,

      idLocation: 0,
      textDesc: '',
      textDescShort: '',

      objCalendar: {}
      // today: moment()
    };

    let currentTimenow = Math.floor(Date.now() / 1000)
    let currentDatenow = ((currentTimenow + 25200) - (currentTimenow + 25200) % (86400)) - 25200
    let diffTime = currentTimenow - currentDatenow

    if (props.startDate) {
      currentTimenow = props.startDate + diffTime
    }
    let startDateTmp = currentTimenow + 5400
    this.state.startDate = this.roundUnixTimestampToHour(startDateTmp)
    this.state.endDate = this.state.startDate + 1800
    this.state.selectedDate = new Date(currentTimenow * 1000)

    if (props.flagEdit) {
      this.state.objCalendar = props.detail || {}

      if (typeof (rxaget(props.detail, 'location', '') === 'object')) {
        this.state.objCalendar['location'] = rxaget(props.detail, 'location.code', '')
        this.state.typeLocation = this.state.objCalendar['location']
      }

      if (typeof (rxaget(props.detail, 'category', '') === 'object')) {
        this.state.objCalendar['category'] = rxaget(props.detail, 'category.code', '')
        this.state.typeCategory = this.state.objCalendar['category']
      }
      this.state.typeCalendar = rxaget(this.state.objCalendar, 'type', '')

      if (rxaget(this.state.objCalendar, 'time_start', 0) > 0) {
        this.state.startDate = rxaget(this.state.objCalendar, 'time_start', '')
        this.state.objCalendar.start_time = convertUnixToDateTime(rxaget(this.state.objCalendar, 'time_start', ''))
      }

      if (rxaget(this.state.objCalendar, 'time_end', 0) > 0) {
        this.state.endDate = rxaget(this.state.objCalendar, 'time_end', '')
        this.state.objCalendar.end_time = convertUnixToDateTime(rxaget(this.state.objCalendar, 'time_end', ''))
      }

      this.state.cntCharInput = rxaget(this.state.objCalendar, 'title', '').length

      // if (rxaget(this.state.objCalendar, 'location', '').indexOf('Phòng ') !== -1) {
      //   this.state.objCalendar.location = this.state.objCalendar.location.replace(/Phòng /g, '')
      // }
      if (this.state.objCalendar && this.state.objCalendar.recipients && this.state.objCalendar.recipients.constructor === Array) {
        let arrRecipients = this.state.objCalendar.recipients.filter(u => !u.owner)
        arrRecipients.forEach(o => { o.old = true })
        this.state.objCalendar.recipients = arrRecipients
        this.state.arrRecipients = arrRecipients
        this.state.arrRecipientsOrigin = JSON.parse(JSON.stringify(arrRecipients))
      }

    } else {
      this.state.objCalendar.status = 'A'
    }

    let language = localStorage.getItem('netaLang') || 'vi'
    this.language = language.replace(/"/g, '')
    this.locale = locale
    if (language.indexOf('en') !== -1) {
      this.locale = 'en'
    }


    this.onChangeDate = this.onChangeDate.bind(this)
    this.onToggleTime = this.onToggleTime.bind(this)

    // this.arrReminder = [
    //   {id: 0, name: 'Trước 15 phút'},
    //   {id: 1, name: 'Trước 30 phút'},
    //   {id: 2, name: 'Trước 45 phút'},
    //   {id: 3, name: 'Trước 2 tiếng'},
    //   {id: -1, name: 'Không nhắc'}
    // ]

    // this.arrReminderChannel = [
    //   {id: 0, name: 'BOBACU'},
    //   {id: 1, name: 'DSTOCK_MOBILE'},
    //   {id: 2, name: 'DGO_MOBILE'}
    // ]

    this.arrStatusCalendar = {
      'A': 'Active',
      'E': 'Expired',
      'C': 'Cancelled'
    }

  }

  componentDidMount() {
    let objCalendar = this.state.objCalendar
    let base_api_neta = global.rxu.config.base_api_neta
    let location_link = base_api_neta + '/api/calendar/location'
    let category_link = base_api_neta + '/api/calendar/category'
    let remind_time_link = base_api_neta + '/api/calendar/remind_time'
    let remind_channel_link = base_api_neta + '/api/calendar/remind_channel'
    let method = 'GET'

    let headers = { 'Content-Type': 'application/json' }
    let netaAuthUser = global.rxu.json(rxgetLocal('rxuserneta'), { user: {} })

    if (rxaget(netaAuthUser, 'user.token', '')) {
      headers['tc-token'] = rxaget(netaAuthUser, 'user.token', '')
    }
    // location_link += '?tc_token=01629d751aa0fbf347e9be116b2d9e239423vTjf'
    fetch(location_link, {
      method: method,
      headers: headers,
      body: null
    }).then(res => res.json()).then((json) => {
      if (json && json.items && json.items.constructor === Array && json.items.length > 0) {
        let objLocation = {}

        for (let item of json.items) {
          item.full_address = item.name + '-' + item.address
          objLocation[item.code] = item
        }

        if (this.state.flagEditCalendar && objCalendar.location && objLocation[objCalendar.location] && objLocation[objCalendar.location]['id']) {
          this.state.idLocation = objLocation[objCalendar.location]['id']
        }
        this.setState({ objLocation: objLocation })
      }
    })
    // category_link += '?tc_token=01629d751aa0fbf347e9be116b2d9e239423vTjf'
    fetch(category_link, {
      method: method,
      headers: headers,
      body: null
    }).then(res => res.json()).then((json) => {
      if (json && json.items && json.items.constructor === Array && json.items.length > 0) {
        let objCategory = {}

        for (let item of json.items) {
          objCategory[item.code] = item
        }

        let updateStateCate = { objCategory: objCategory }
        if (!objCalendar['category']) {
          objCalendar['category'] = 'C01'
          updateStateCate['objCalendar'] = objCalendar
          updateStateCate['typeCategory'] = objCalendar['category']
        }
        this.setState(updateStateCate)
      }
    })

    // remind_time_link += '?tc_token=01629d751aa0fbf347e9be116b2d9e239423vTjf'
    fetch(remind_time_link, {
      method: method,
      headers: headers,
      body: null
    }).then(res => res.json()).then((json) => {
      if (json && json.items && json.items.constructor === Array && json.items.length > 0) {
        objCalendar['remind_time'] = json.items[0]
        this.setState({ arrReminder: json.items, typeReminder: json.items[0], objCalendar: objCalendar })
      }
    })

    // fetch(remind_channel_link, { 
    //   method: method, 
    //   headers: headers,
    //   body: null
    // }).then( res => res.json()).then((json) => {
    //   if (json && json.items && json.items.constructor === Array && json.items.length > 0) {
    //     this.setState({arrReminderChannel: json.items})
    //   }
    // })
  }

  roundUnixTimestampToHour(timestamp) {
    var roundedTimestamp = Math.floor(timestamp / 1800) * 1800;
    return roundedTimestamp;
  }

  onChangeDate(date) {
    let newDateTime = Math.floor(date.getTime() / 1000)
    let objCalendar = this.state.objCalendar

    if (this.state.toggleShowTime) {
      newDateTime = ((newDateTime + 25200) - (newDateTime + 25200) % (86400)) - 25200
    }


    let updateState = {
      selectedDate: date
    }

    if (this.state.flagClickDate === 'startDate') {
      updateState[this.state.flagClickDate] = newDateTime
      objCalendar['start_time'] = convertUnixToDateTime(newDateTime)
      if (!updateState['endDate']) {
        updateState['endDate'] = newDateTime + 1800
        objCalendar['end_time'] = convertUnixToDateTime(newDateTime + 1800)
      }

      this.getCalendarViewAll(newDateTime)

    } else if (this.state.flagClickDate === 'endDate') {

      if (!objCalendar['start_time']) {
        let timeStampTmp = Math.floor(new Date().getTime() / 1000)
        objCalendar['start_time'] = convertUnixToDateTime(timeStampTmp)
      }

      if (objCalendar['start_time']) {
        let startTime = new Date(objCalendar['start_time']).getTime() / 1000
        if (newDateTime < startTime) {
          if (isElectron() && window && window.ipcRenderer) {
            window.ipcRenderer.send('dialog_alert', translate('Please select an end time greater than start'))
          } else {
            alert(translate('Please select an end time greater than start'))
          }
          return
        }
        let datenow = (((startTime + 25200) - (startTime + 25200) % (86400)) - 25200) + 86399
        if (newDateTime > datenow) {
          if (isElectron() && window && window.ipcRenderer) {
            window.ipcRenderer.send('dialog_alert', translate('You can only create reminder during the day'))
          } else {
            alert(translate('You can only create reminder during the day'))
          }
          return
        }
      }

      updateState[this.state.flagClickDate] = newDateTime
      objCalendar['end_time'] = convertUnixToDateTime(newDateTime)
    }

    this.setState(updateState)

  }

  onToggleTime(e) {
    let toggleShowTime = this.state.toggleShowTime
    this.setState({
      toggleShowTime: !toggleShowTime
    })
  }

  showPopupDateTime(type) {
    let updateState = {
      flagClickDate: type,
      flagCheckEdit: true,
      flagPopupDateTime: true
    }

    if (this.state.flagEditCalendar) {
      let objCalendar = this.state.objCalendar
      if (type === 'startDate') {
        updateState['selectedDate'] = new Date(objCalendar.time_start * 1000)
      } else if (type === 'endDate') {
        updateState['selectedDate'] = new Date(objCalendar.time_end * 1000)
      }
      updateState['flagCheckEditTime'] = true
    }


    this.getCalendarViewAll()
    this.setState(updateState)
  }

  getCalendarViewAll(startTime) {
    let idLocation = this.state.idLocation
    let startDate = startTime || this.state.startDate
    let firstDate = ((startDate + 25200) - (startDate + 25200) % (86400)) - 25200
    let lastDate = firstDate + 86399
    let firstDateStr = convertUnixToDateTime(firstDate)
    let lastDateStr = convertUnixToDateTime(lastDate)

    let base_api_neta = global.rxu.config.base_api_neta
    let view_all_link = base_api_neta + '/api/calendar/view_all'
    let headers = { 'Content-Type': 'application/json' }
    let netaAuthUser = global.rxu.json(rxgetLocal('rxuserneta'), { user: {} })

    if (rxaget(netaAuthUser, 'user.token', '')) {
      headers['tc-token'] = rxaget(netaAuthUser, 'user.token', '')
    }

    if (idLocation !== 0) {
      let params = {
        page: 1,
        size: 200,
        location_id: idLocation,
        start_time: firstDateStr,
        end_time: lastDateStr
      }

      //params['tc_token'] = '01629d751aa0fbf347e9be116b2d9e239423vTjf'

      // Make params
      let tempBody = ''
      for (let property in params) {
        if (params.hasOwnProperty(property)) {
          tempBody += `${property}=${params[property]}&`
        }
      }

      fetch(view_all_link + '?' + tempBody, {
        method: 'GET',
        headers: headers,
        body: null
      }).then(res => res.json()).then((json) => {
        if (json && json.items && json.items.constructor === Array && json.items.length > 0) {
          // arrBlacklistTime
          let arrBlacklistTime = []
          for (let item of json.items) {
            let objDate = {
              from: convertUnixTimeDate(item.start_time),
              to: convertUnixTimeDate(item.end_time)
            }
            arrBlacklistTime.push(objDate)
          }

          this.setState({ arrBlacklistTime: arrBlacklistTime })
        }
      })
    }
  }

  handleClickOutside(e) {
    if (e.target.className === 'zchat_choose_calendar-bg') {
      this.setState({
        flagPopupDateTime: false,
        flagPopupTypeCalendar: false,
        flagNoteDescCalendar: false,
        flagReminder: false,
        flagReminderChannel: false,
        flagReminderStatus: false,
        flagShowLocation: false,
        flagClickDate: ''
      })
    }
  }

  showAddMember() {
    this.setState({
      flagShowMember: true,
      flagCheckEdit: true,
      flagRecipientsMember: false
    })
  }

  showRecipientsMember() {
    let flagRecipientsMember = this.state.flagRecipientsMember
    this.setState({
      flagRecipientsMember: !flagRecipientsMember
    })
  }

  onClickCloseAddMember() {
    this.setState({
      flagShowMember: false,
      flagRecipientsMember: false
    })
  }

  onClickSaveMember(arrUsers) {
    let objCalendar = this.state.objCalendar
    let userLocal = global.rxu.json(rxgetLocal('rxuserneta'), { user: {} })
    let userOwner = {
      username: rxaget(userLocal, 'user.phone', ''),
      full_name: rxaget(userLocal, 'user.name', ''),
      optional: true,
      owner: true
    }
    let arrRecipients = (this.state.flagEditCalendar) ? [] : [userOwner]

    if (arrUsers && arrUsers.constructor === Array && arrUsers.length > 0) {
      for (let ouser of arrUsers) {
        arrRecipients.push({
          username: rxaget(ouser, 'phone', '') || rxaget(ouser, 'username', ''),
          full_name: rxaget(ouser, 'full_name', ''),
          optional: false,
          owner: false
          // old: ouser.old || false
        })
      }
    }

    objCalendar['recipients'] = arrRecipients

    this.setState({
      arrRecipients: arrUsers,
      objCalendar: objCalendar,
      flagShowMember: false
    })
  }

  showPopupTypeCalendar() {
    this.setState({
      flagPopupTypeCalendar: true
    })
  }

  showPopupNoteDescCalendar() {
    let objCalendar = this.state.objCalendar
    let textDesc = this.state.textDesc
    let textDescShort = this.state.textDescShort

    if (objCalendar['full_description']) {
      textDesc = objCalendar['full_description']
    }

    if (objCalendar['short_description']) {
      textDescShort = objCalendar['short_description']
    }

    this.setState({
      textDesc: textDesc,
      textDescShort: textDescShort,
      flagNoteDescCalendar: true
    })
  }

  showPopupReminderCalendar() {
    this.setState({
      flagReminder: true
    })
  }

  showPopupReminderChannel() {
    this.setState({
      flagReminderChannel: true
    })
  }

  showPopupReminderStatus() {
    this.setState({
      flagReminderStatus: true,
      flagCheckEdit: true
    })
  }

  showPopupLocation() {
    this.setState({
      flagShowLocation: true,
      flagCheckEdit: true
    })
  }

  showPopupCategory() {
    this.setState({
      flagShowCategory: true,
      flagCheckEdit: true
    })
  }

  cancelDescCalendar() {
    this.setState({
      flagNoteDescCalendar: false
    })
  }

  saveDescCalendar() {
    let objCalendar = this.state.objCalendar
    let textDesc = this.state.textDesc
    let textDescShort = this.state.textDescShort

    if (textDesc) {
      objCalendar['full_description'] = textDesc
    } else {
      delete objCalendar['full_description']
    }

    if (textDescShort) {
      objCalendar['short_description'] = textDescShort
    } else {
      delete objCalendar['short_description']
    }

    this.setState({
      objCalendar: objCalendar,
      flagNoteDescCalendar: false
    })
  }

  saveReminderCalendar() {
    let objCalendar = this.state.objCalendar
    let updateState = { flagReminder: false }
    if (!rxaget(objCalendar, 'remind_time', '')) {
      objCalendar['remind_time'] = '15 phút'

      updateState = {
        objCalendar: objCalendar,
        flagReminder: false,
        typeReminder: ''
      }
    }
    this.setState(updateState)
  }

  saveReminderChannel() {
    this.setState({
      flagReminderChannel: false
    })
  }

  saveReminderStatus() {
    this.setState({
      flagReminderStatus: false,
      flagCheckEdit: true
    })
  }

  saveLocation() {
    this.setState({
      flagCheckEdit: true,
      flagShowLocation: false
    })
  }

  saveCategory() {
    this.setState({
      flagCheckEdit: true,
      flagShowCategory: false
    })
  }

  chooseTypeCalendar(type) {
    this.setState({
      typeCalendar: type,
      flagPopupTypeCalendar: false
    })
  }

  chooseTypeReminder(type, name) {
    let objCalendar = this.state.objCalendar
    let updateState = {}
    if (name == 'time') {
      // let findReminder = this.arrReminder.find(obj => obj.id == type)
      // if (findReminder) {
      objCalendar['remind_time'] = type
      // }
      updateState['objCalendar'] = objCalendar
      updateState['typeReminder'] = type
    } else if (name == 'channel') {
      let findReminder = this.arrReminderChannel.find(obj => obj.id == type)
      if (findReminder) {
        objCalendar['remind_channel'] = findReminder.name
      }
      updateState['objCalendar'] = objCalendar
      updateState['typeReminderChannel'] = type
    } else if (name == 'status') {
      objCalendar['status'] = type
      updateState['objCalendar'] = objCalendar
      updateState['typeReminderStatus'] = type
    } else if (name == 'location') {
      if (this.state.objLocation && this.state.objLocation[type] && this.state.objLocation[type]['id']) {
        updateState['idLocation'] = this.state.objLocation[type]['id']
      }
      objCalendar['location'] = type
      updateState['objCalendar'] = objCalendar
      updateState['typeLocation'] = type
    } else if (name == 'category') {
      objCalendar['category'] = type
      updateState['objCalendar'] = objCalendar
      updateState['typeCategory'] = type
    }

    this.setState(updateState)
  }

  closeCalendarBox() {
    this.setState({
      flagPopupDateTime: false
    })
  }

  onChangeTextCalendar(e, key) {
    let objCalendar = this.state.objCalendar
    let value = e.target.value

    if (value) {
      objCalendar[key] = value
    } else {
      delete objCalendar[key]
    }

    let updateState = {
      objCalendar: objCalendar,
      flagCheckEdit: true
    }
    if (key == 'title') {
      updateState['cntCharInput'] = (value) ? Number(value.length) : 0
    }

    this.setState(updateState)
  }

  onChangeDescCalendar(e) {
    let value = e.target.value

    let cntChar = (value) ? Number(value.length) : 0

    this.setState({
      textDesc: value,
      flagCheckEdit: true,
      cntCharTextArea: cntChar
    })
  }

  onChangeDescCalendarSort(e) {
    let value = e.target.value

    // let cntChar = (value) ? Number(value.length) : 0

    this.setState({
      textDescShort: value
    })
  }

  changeChooseReminder(e) {
    console.log(e)
  }

  filterPassedTime = (time) => {
    const arrBlacklistTime = this.state.arrBlacklistTime
    const currentDate = new Date()
    const selectedDate = new Date(time)
    const selectedTimeSecond = Math.floor(selectedDate.getTime() / 1000)
    let flagChecked = (currentDate.getTime() < selectedDate.getTime()) ? true : false
    if (flagChecked) {
      for (let objTime of arrBlacklistTime) {
        if (objTime.from <= selectedTimeSecond && selectedTimeSecond <= objTime.to) {
          flagChecked = false
          break
        }
      }
    }

    return flagChecked
  }

  filterPassedDate = (time) => {
    const currentDate = new Date()
    const selectedDate = new Date(time)

    let timenow = Math.floor(currentDate.getTime() / 1000)
    let datenow = ((timenow + 25200) - (timenow + 25200) % (86400)) - 25200
    let dateTimeFirst = new Date(datenow * 1000)

    return dateTimeFirst.getTime() <= selectedDate.getTime()
  }

  saveCalendar() {
    let objCalendar = this.state.objCalendar

    // objCalendar['type'] = this.state.typeCalendar

    let netaAuthUser = global.rxu.json(rxgetLocal('rxuserneta'), { user: {} })

    // objCalendar['owner'] = netaAuthUser['user']['name'] || netaAuthUser['user']['phone']

    let base_api_neta = global.rxu.config.base_api_neta
    let calendar_link = base_api_neta + '/api/calendar'
    let calendar_delete = base_api_neta + '/api/calendar/recipient'
    let method = 'POST'

    if (this.state.flagEditCalendar) {
      method = 'PUT'
      calendar_link = base_api_neta + '/api/calendar/update'
    }

    if (!objCalendar.start_time) {
      objCalendar.start_time = convertUnixToDateTime(this.state.startDate)
    }

    if (!objCalendar.end_time) {
      objCalendar.end_time = convertUnixToDateTime(this.state.endDate)
    }

    objCalendar.remind_channel = 'BOBACU'
    objCalendar.status = 'A'

    if (objCalendar.location && objCalendar.location.indexOf('Phòng ') !== -1) {
      objCalendar.location = objCalendar.location.replace(/Phòng /g, '')
    }

    let usersIdRemoved = []
    let usersArrUpdate = []
    if (this.state.flagEditCalendar) {
      if (objCalendar.category && objCalendar.category.indexOf(' ') !== -1) {

        if (isElectron() && window && window.ipcRenderer) {
          window.ipcRenderer.send('dialog_alert', 'Vui lòng chọn lại nhóm sự kiện')
        } else {
          alert('Vui lòng chọn lại nhóm sự kiện')
        }
        return
      }
      if (objCalendar && objCalendar.recipients && objCalendar.recipients.constructor === Array && objCalendar.recipients.length > 0) {
        // objCalendar.recipients = objCalendar.recipients.filter(u => u.old === false)
        let usersArrOld = this.state.arrRecipientsOrigin.map(u => u.username)
        let usersArrNew = objCalendar.recipients.map(u => u.username)

        let usersUpdate = objCalendar.recipients.filter(u => usersArrOld.indexOf(u.username) === -1)
        if (usersUpdate && usersUpdate.constructor === Array && usersUpdate.length > 0) {
          for (let userNew of usersUpdate) {
            usersArrUpdate.push({
              username: rxaget(userNew, 'username', ''),
              full_name: rxaget(userNew, 'full_name', ''),
              optional: false,
              owner: false
            })
          }
        }

        let usersRemove = this.state.arrRecipientsOrigin.filter(u => usersArrNew.indexOf(u.username) === -1)
        if (usersRemove && usersRemove.constructor === Array && usersRemove.length > 0) {
          usersIdRemoved = usersRemove.map(u => u.id)
        }

        objCalendar.recipients = usersArrUpdate
      }
    }


    if (this.state.toggleShowTime) {
      let newStartDate = ((this.state.startDate + 25200) - (this.state.startDate + 25200) % (86400)) - 25200
      objCalendar.start_time = convertUnixToDateTime(newStartDate)
    }

    if (!objCalendar.recipients) {
      let userLocal = global.rxu.json(rxgetLocal('rxuserneta'), { user: {} })
      objCalendar.recipients = [{
        username: rxaget(userLocal, 'user.phone', ''),
        full_name: rxaget(userLocal, 'user.name', ''),
        optional: true,
        owner: true
      }]
    }

    let headers = { 'Content-Type': 'application/json' }

    // if (rxaget(netaAuthUser, 'user.token', '')) {
    // objCalendar['tc_token'] = '01629d751aa0fbf347e9be116b2d9e239423vTjf'// rxaget(netaAuthUser, 'user.token', '')  
    // }

    headers['TC-Token'] = rxaget(netaAuthUser, 'user.token', '')

    if (this.state.flagCheckEdit) {
      if (usersIdRemoved && usersIdRemoved.constructor === Array && usersIdRemoved.length > 0 && objCalendar.id) {
        let paramsDelete = {
          'calendar_id': objCalendar.id,
          'recipient_ids': usersIdRemoved
        }

        // paramsDelete['tc_token'] = '01629d751aa0fbf347e9be116b2d9e239423vTjf'

        fetch(calendar_delete, {
          method: 'DELETE',
          body: JSON.stringify(paramsDelete),
          headers: headers
        }).then((res) => { console.log(res) })
          .catch(err => console.log(err))
      }

      fetch(calendar_link, {
        method: method,
        headers: headers,
        body: JSON.stringify(objCalendar)
      }).then(res => res.json()).then((json) => {
        if (json && (json.start_time || json.message === "success")) {
          if (this.state.flagCheckEditTime) {
            try {
              this.props.backFuncReset(objCalendar.start_time || '')
            } catch (e2) {
              this.props.backFunc(true)
            }
          } else {
            this.props.backFunc(true)
          }

        } else {
          if (json && json.message) {
            let err_mess = errCode(json.error, json.message || '')
            if (isElectron() && window && window.ipcRenderer) {
              window.ipcRenderer.send('dialog_alert', err_mess)
            } else {
              alert(err_mess)
            }
          }
        }
      })
    }

  }

  backHomeCalendar() {
    this.setState({
      flagPopupConfirm: true
    })
  }

  confirmBack() {
    this.setState({
      flagPopupConfirm: false
    }, () => {
      this.props.backFunc()
    })
  }

  cancelBack() {
    this.setState({
      flagPopupConfirm: false
    })
  }

  render() {
    let codeLocation = rxaget(this.state.objCalendar, 'location', '').replace(/Phòng /g, '')
    return (
      <>
        <div className="zchat_popup_calendar_mainbox">
          <div className="zchat_popup_calendar_header">
            <div className="zchat_popup_calendar_title">{(this.state.flagEditCalendar) ? translate('Edit event') : translate('Create new event')}</div>
            <div className="zchat_popup_calendar_btn_left" onClick={e => this.backHomeCalendar()}>
              <img className="btn-back-calendar" alt="" src="./images/default/icons/icon-back.svg" />
            </div>
            <div className="zchat_popup_calendar_btn_right" onClick={e => this.saveCalendar()}>
              <span className={this.state.flagCheckEdit ? "btn_save_calendar" : "btn_save_calendar disable"}>{translate('Done')}</span>
            </div>
          </div>

          <div className="zchat_popup_calendar_body">
            <div className="calendar-container">
              <div className="calendar-box">

                <div className="row-calendar-maininput">
                  <div className="row-calendar-icon">
                    <img src="./images/default/icons/icon-edit.svg" alt="" />
                  </div>

                  <div className="row-calendar-contain">
                    <input className="row-calendar-contain-input" type="text" placeholder={translate('Enter title')} value={rxaget(this.state.objCalendar, 'title', '')} maxLength="255" onChange={e => this.onChangeTextCalendar(e, 'title')} />
                    <div className="zchat_count_input">
                      <span className="zchat_count_input-current">{this.state.cntCharInput}</span>
                      <span className="zchat_count_input-maximum">/ 255</span>
                    </div>
                  </div>
                </div>
                {/* <div className="row-calendar-title-maininput">
                  <div className="row-calendar-title-icon">
                    <img src="./images/default/icons/icon-edit.svg" alt="" />
                  </div>

                  <div className="row-calendar-title-contain">
                    <span className="row-calendar-contain-textarea" role="textbox" placeholderTitle={translate('Enter title')} value={rxaget(this.state.objCalendar, 'title', '')} contentEditable='true'></span>
                    <div className="zchat_count_input-title">
                      <span className="zchat_count_input-current">{this.state.cntCharInput}</span>
                      <span className="zchat_count_input-maximum">/ 255</span>
                    </div>
                  </div>
                </div> */}

                {/* <div className="row-calendar-maininput">
                  <div className="row-calendar-icon">
                    <img src="./images/default/icons/icon-location.svg" alt="" />
                  </div>
                  
                  <div className="row-calendar-contain">
                    <input className="row-calendar-contain-input" type="text" placeholder="Nhập địa điểm" value={rxaget(this.state.objCalendar, 'location', '')} onChange={e => this.onChangeTextCalendar(e, 'location')}/>
                  </div>
                </div> */}

                <div className="row-calendar-maininput">
                  <div className="row-calendar-icon">
                    <img src="./images/default/icons/icon-location.svg" alt="" />
                  </div>

                  <div className="row-calendar-contain" onClick={e => this.showPopupLocation()}>
                    <div className="row-calendar-text-left">
                      {translate('Location')}
                    </div>
                    <div className="row-calendar-action-right">
                      <img src="./images/default/icons/icon-dropnext.svg" alt="" />
                    </div>
                  </div>
                </div>
                {rxaget(this.state.objCalendar, 'location', '') && <>
                  <div className="row-calendar-info-maininput">
                    <div className="row-calendar-fulltext-left">
                      {(this.state.objLocation[codeLocation]) ? this.state.objLocation[codeLocation]['full_address'] : rxaget(this.state.objCalendar, 'location', '')}
                    </div>
                  </div>
                  {/* <div className="row-calendar-line"></div> */}
                </>}


                <div className="row-calendar-maininput">
                  <div className="row-calendar-icon">
                    <img src="./images/default/icons/icon-calendar.svg" alt="" />
                  </div>

                  <div className="row-calendar-contain" onClick={e => this.showPopupCategory()}>
                    <div className="row-calendar-text-left">
                      {translate('Event Category')}
                    </div>
                    <div className="row-calendar-action-right">
                      <img src="./images/default/icons/icon-dropnext.svg" alt="" />
                    </div>
                  </div>
                </div>
                {rxaget(this.state.objCalendar, 'category', '') && <>
                  <div className="row-calendar-info-maininput">
                    <div className="row-calendar-fulltext-left">
                      {(this.state.objCategory[rxaget(this.state.objCalendar, 'category', '')]) ? this.state.objCategory[rxaget(this.state.objCalendar, 'category', '')]['name'] : rxaget(this.state.objCalendar, 'category', '')}
                    </div>
                  </div>
                </>}

                <div className="row-calendar-maininput">
                  <div className="row-calendar-icon">
                    <img src="./images/default/icons/icon-recent.svg" alt="" />
                  </div>

                  <div className="row-calendar-contain">
                    <div className="row-calendar-text-left">
                      {translate('Time')}
                    </div>
                    <div className="row-calendar-action-right">

                    </div>
                  </div>
                </div>

                <div className="row-calendar-datetime-maininput">
                  <div className="row-calendar-datetime-text-left">
                    {translate('Start')}
                  </div>
                  <div className="row-calendar-datetime-action-right" onClick={e => this.showPopupDateTime('startDate')}>
                    {!this.state.toggleShowTime && <div className="row-calendar-time-text">
                      {convertUnixToDateTime(this.state.startDate, 'hour')}
                    </div>}

                    <div className="row-calendar-date-text">
                      {convertUnixToDateTime(this.state.startDate, 'date')}
                    </div>
                  </div>
                </div>

                <div className="row-calendar-datetime-maininput">
                  <div className="row-calendar-datetime-text-left">
                    {translate('End')}
                  </div>
                  <div className="row-calendar-datetime-action-right" onClick={e => this.showPopupDateTime('endDate')}>
                    {!this.state.toggleShowTime && <div className="row-calendar-time-text">
                      {convertUnixToDateTime(this.state.endDate, 'hour')}
                    </div>}

                    <div className="row-calendar-date-text">
                      {convertUnixToDateTime(this.state.endDate, 'date')}
                    </div>
                  </div>
                </div>

                <div className="row-calendar-maininput">
                  <div className="row-calendar-icon">
                    <img src="./images/default/icons/icon-user-invite.svg" alt="" />
                  </div>

                  <div className="row-calendar-contain" onClick={e => this.showAddMember()}>
                    <div className="row-calendar-text-left" >
                      {translate('Participants')}
                    </div>
                    <div className="row-calendar-action-right">
                      {(this.state.arrRecipients.length > 0) && <span className='calendar-amount-recipients' onClick={e => this.showRecipientsMember()}>{this.state.arrRecipients.length}</span>}
                      <img src="./images/default/icons/icon-dropnext.svg" alt="" />
                    </div>
                  </div>
                </div>

                {(this.state.flagRecipientsMember && this.state.arrRecipients && this.state.arrRecipients.length > 0) && <div className='calendar-list-member'>
                  {this.state.arrRecipients.map((user, index) => <div key={index}>
                    <div className="row-calendar-info-maininput">
                      <div className="ava-joiner-box">
                        <span className='ava-joiner-span' style={{ background: `${changeColorAva(rxaget(user, 'Id', '').length)}` }}>{textAva(rxChangeSlug(rxaget(user, 'full_name', ''))) || textAva(rxaget(user, 'phone', ''))}</span>
                      </div>

                      <div className="fullname-joiner-text">
                        {rxaget(user, 'full_name', '') || rxaget(user, 'phone', '')}
                      </div>
                    </div>
                  </div>)}
                </div>}

                <div className={rxaget(this.state.objCalendar, 'short_description', '') ? 'row-calendar-maininput-notedesc' : 'row-calendar-maininput'} >
                  <div className="row-calendar-icon">
                    <img src="./images/default/icons/icon-quick-message.svg" alt="" />
                  </div>

                  <div className="row-calendar-contain" onClick={e => this.showPopupNoteDescCalendar()}>
                    <div className="row-calendar-text-left">
                      {translate('Note')}
                    </div>
                    <div className="row-calendar-action-right">
                      <img src="./images/default/icons/icon-dropnext.svg" alt="" />
                    </div>
                  </div>
                </div>

                {rxaget(this.state.objCalendar, 'short_description', '') && <>
                  <div className="row-calendar-info-descinput">
                    <div className="row-calendar-fulltext-left">
                      <div dangerouslySetInnerHTML={{ __html: rxaget(this.state.objCalendar, 'short_description', '').replace(/\n/g, '</br>') }} />
                    </div>
                  </div>
                  {/* <div className="row-calendar-line"></div> */}
                </>}

                <div className="row-calendar-maininput">
                  <div className="row-calendar-icon">
                    <img src="./images/default/icons/icon-reminder.svg" alt="" />
                  </div>

                  <div className="row-calendar-contain" onClick={e => this.showPopupReminderCalendar()}>
                    <div className="row-calendar-text-left">
                      {translate('Reminder')}
                    </div>
                    <div className="row-calendar-action-right">
                      {(rxaget(this.state.objCalendar, 'remind_time', '')) && <span className='calendar-amount-recipients'>{rxaget(this.state.objCalendar, 'remind_time', '')}</span>}
                      <img src="./images/default/icons/icon-dropnext.svg" alt="" />
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        {this.state.flagPopupDateTime && <>
          <div className="zchat_choose_calendar-bg" onClick={e => this.handleClickOutside(e)}></div>
          <div className="zchat_calendar_datetime_box">
            <span className='title-calendar-box'>{translate('Select time')}</span>
            <div className={(!this.state.toggleShowTime) ? "zchat_choose_calendar-box" : "zchat_choose_calendar-datebox"} >

              <DatePicker
                selected={this.state.selectedDate}
                onChange={this.onChangeDate}
                dateFormat="MMMM d, yyyy hh:mm aa"
                locale={this.locale}
                showTimeSelect={!this.state.toggleShowTime}
                filterTime={this.filterPassedTime}
                filterDate={this.filterPassedDate}
                inline
              />


            </div>
            <span className='btn-close-calendar-box' onClick={e => this.closeCalendarBox(e)}>{translate('Done')}</span>
          </div>
        </>}

        {this.state.flagPopupTypeCalendar && <>
          <div className="zchat_choose_calendar-bg" onClick={e => this.handleClickOutside(e)}></div>
          <div className="zchat_choose_typecalendar-box">
            <div className="zchat_choose_typecalendar-header">
              Loại lịch
            </div>
            {["Public", "Thư mời"].map((type, index) => <div className={(this.state.typeCalendar === type) ? "zchat_choose_typecalendar-row active-row" : "zchat_choose_typecalendar-row"} key={index} onClick={e => this.chooseTypeCalendar(type)}>
              {type}
            </div>)}
          </div>
        </>}

        {this.state.flagNoteDescCalendar && <>
          <div className="zchat_choose_calendar-bg" onClick={e => this.handleClickOutside(e)}></div>
          <div className="zchat_notecalendar-box">
            <div className="zchat_notecalendar-header">
              {translate('Note')}
            </div>
            <div className="zchat_notecalendar-desc-body">
              <input type="text" autoComplete="off" placeholder="Mô tả ngắn gọn" className="zchat_notecalendar-input-shortdesc" maxLength="255" value={rxaget(this.state, 'textDescShort', '')} onChange={e => this.onChangeDescCalendarSort(e)} />
            </div>

            <div className="zchat_notecalendar-desc-body">
              <textarea type="text" autoComplete="off" placeholder={translate('Description')} maxLength="2000" className="zchat_notecalendar-input-longdesc" value={rxaget(this.state, 'textDesc', '')} onChange={e => this.onChangeDescCalendar(e)} />

              <div className="zchat_count_textarea">
                <span className="zchat_count_textarea-current">{this.state.cntCharTextArea}</span>
                <span className="zchat_count_textarea-maximum">/ 2000</span>
              </div>
            </div>
            <div className="zchat_choose_notecalendar-button">
              <div className="zchat_notecalendar-btn-cancel" onClick={e => this.cancelDescCalendar()}>
                {translate('Cancel')}
              </div>

              <div className="zchat_notecalendar-btn-save" onClick={e => this.saveDescCalendar()}>
                {translate('Save')}
              </div>
            </div>
          </div>
        </>}

        {this.state.flagReminder && <>
          <div className="zchat_choose_calendar-bg" onClick={e => this.handleClickOutside(e)}></div>
          <div className="zchat_choose_reminder-box">
            <div className="zchat_choose_reminder-header">
              {translate('Reminder')}
              <span className="zchat_choose_reminder-save" onClick={e => this.saveReminderCalendar(e)}>{translate('Done')}</span>
            </div>
            {this.state.arrReminder.map((reminderTime, index) => <div className="zchat_choose_reminder-row" key={index} onClick={e => this.chooseTypeReminder(reminderTime, 'time')}>
              <div className="reminder_checked">
                <label className="container100">
                  <input className="checkmark1" type="checkbox" checked={this.state.typeReminder === reminderTime} onChange={(e) => this.changeChooseReminder(e)} />
                  <span className="checkmark-reminder"></span>
                </label>
              </div>

              {reminderTime}
              <span className="zchat_reminder-link"></span>
            </div>)}
          </div>
        </>}

        {this.state.flagReminderChannel && <>
          <div className="zchat_choose_calendar-bg" onClick={e => this.handleClickOutside(e)}></div>
          <div className="zchat_choose_reminder-box">
            <div className="zchat_choose_reminder-header">
              Kênh nhắc lịch
              <span className="zchat_choose_reminder-save" onClick={e => this.saveReminderChannel(e)}>{translate('Done')}</span>
            </div>
            {this.arrReminderChannel.map((type, index) => <div className="zchat_choose_reminder-row" key={index} onClick={e => this.chooseTypeReminder(type.id, 'channel')}>
              <div className="reminder_checked">
                <label className="container100">
                  <input className="checkmark1" type="checkbox" checked={this.state.typeReminderChannel === type.id} onChange={(e) => this.changeChooseReminder(e)} />
                  <span className="checkmark-reminder"></span>
                </label>
              </div>

              {type.name}
              <span className="zchat_reminder-link"></span>
            </div>)}
          </div>
        </>}

        {this.state.flagReminderStatus && <>
          <div className="zchat_choose_calendar-bg" onClick={e => this.handleClickOutside(e)}></div>
          <div className="zchat_choose_reminder-box">
            <div className="zchat_choose_reminder-header">
              Trạng thái lịch
              <span className="zchat_choose_reminder-save" onClick={e => this.saveReminderStatus(e)}>{translate('Done')}</span>
            </div>
            {Object.keys(this.arrStatusCalendar).map((type, index) => <div className="zchat_choose_reminder-row" key={index} onClick={e => this.chooseTypeReminder(type, 'status')}>
              <div className="reminder_checked">
                <label className="container100">
                  <input className="checkmark1" type="checkbox" checked={this.state.typeReminderStatus === type} onChange={(e) => this.changeChooseReminder(e)} />
                  <span className="checkmark-reminder"></span>
                </label>
              </div>

              {this.arrStatusCalendar[type]}
              <span className="zchat_reminder-link"></span>
            </div>)}
          </div>
        </>}

        {this.state.flagShowLocation && <>
          <div className="zchat_choose_calendar-bg" onClick={e => this.handleClickOutside(e)}></div>
          <div className="zchat_choose_location-box">
            <div className="zchat_choose_reminder-header">
              {translate('Location')}
              <span className="zchat_choose_reminder-save" onClick={e => this.saveLocation(e)}>{translate('Done')}</span>
            </div>
            <div className="zchat_choose_box-scroll">
              {Object.keys(this.state.objLocation).map((keyLocation, index) => <div className="zchat_choose_reminder-row" key={index} onClick={e => this.chooseTypeReminder(keyLocation, 'location')}>
                <div className="reminder_checked">
                  <label className="container100">
                    <input className="checkmark1" type="checkbox" checked={this.state.typeLocation === keyLocation} onChange={(e) => this.changeChooseReminder(e)} />
                    <span className="checkmark-reminder"></span>
                  </label>
                </div>

                {rxaget(this.state.objLocation, keyLocation + '.name', '')} - {rxaget(this.state.objLocation, keyLocation + '.address', '')}
                <span className="zchat_reminder-link"></span>
              </div>)}
            </div>
          </div>
        </>}

        {this.state.flagShowCategory && <>
          <div className="zchat_choose_calendar-bg" onClick={e => this.handleClickOutside(e)}></div>
          <div className="zchat_choose_location-box">
            <div className="zchat_choose_reminder-header">
              {translate('Event Category')}
              <span className="zchat_choose_reminder-save" onClick={e => this.saveCategory(e)}>{translate('Done')}</span>
            </div>
            <div className="zchat_choose_box-scroll">
              {Object.keys(this.state.objCategory).map((keyCate, index) => <div className="zchat_choose_reminder-row" key={index} onClick={e => this.chooseTypeReminder(keyCate, 'category')}>
                <div className="reminder_checked">
                  <label className="container100">
                    <input className="checkmark1" type="checkbox" checked={this.state.typeCategory === keyCate} onChange={(e) => this.changeChooseReminder(e)} />
                    <span className="checkmark-reminder"></span>
                  </label>
                </div>

                {rxaget(this.state.objCategory, keyCate + '.name', '')}
                <span className="zchat_reminder-link"></span>
              </div>)}
            </div>
          </div>
        </>}


        {this.state.flagShowMember && <AddMemberCalendar
          onClickCloseAddMember={() => this.onClickCloseAddMember()}
          onClickSaveMember={(arrUsers) => this.onClickSaveMember(arrUsers)}
          arrRecipients={this.state.arrRecipients}
        />}

        {this.state.flagPopupConfirm && <>
          <div className="zchat_choose_calendar-bg"></div>
          <div className="zchat_confirmcalendar-box">
            <div className="zchat_confirm-calendar-alert">
              <span>
                {translate('Reminder has not been completed, do you want to finish it?')}
              </span>
            </div>

            <div className="zchat_choose_notecalendar-button">
              <div className="zchat_notecalendar-btn-cancel" onClick={e => this.cancelBack()}>
                {translate('Cancel')}
              </div>

              <div className="zchat_notecalendar-btn-save" onClick={e => this.confirmBack()}>
                {translate('Accept')}
              </div>
            </div>
          </div>
        </>}

      </>


    )
  }
}

export default CreateCalendar;